export enum DesignatedUnitTableType {
  Active = 'Active',
  Inactive = 'Inactive'
}
